function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 21.5c5.8 0 10.5-4.7 10.5-10.5C21.5 5.203 16.8.502 11 .502 5.203.501.502 5.202.502 11.001c0 5.798 4.701 10.499 10.5 10.499zm-1.243-4.68a.296.296 0 00.296.303h1.895c.166 0 .3-.137.296-.303l-.186-7.482a.296.296 0 00-.296-.289h-1.524a.296.296 0 00-.296.29l-.185 7.481zM12.36 6.188c0-.734-.6-1.31-1.36-1.31-.759 0-1.36.576-1.36 1.31 0 .734.601 1.31 1.36 1.31.76 0 1.36-.576 1.36-1.31z",
  fill: "#C24100"
})));